import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    marginTop: 16,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
  },

  headerContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },

  newAuthenticationnButton: {
    height: '2.25rem',
    padding: '0.5rem 1rem',
  },

  description: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#191C1A',
  },

  tableBase: {
    width: '100%',
    borderSpacing: 0,
  },

  tableHeader: {
    '& th': {
      fontFamily: 'Nunito',
      fontWeight: '600',
      fontSize: '0.875rem',
      lineHeight: '2rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  tableBody: {
    '& td': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },

    '& tr': {
      cursor: 'pointer',
      transition: 'all 300ms ease',

      '&:hover': {
        backgroundColor: getRGBA('#000000', 0.04),
        borderColor: getRGBA('#000000', 0.4),
      },
    },
  },

  tableSize: {
    width: '25%',
    padding: '0.25rem 1rem',
    alignItems: 'start',
    '& span': {
      textTransform: 'capitalize',
    },
  },

  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '50%',
    border: `1px solid ${getRGBA('#000000', 0.12)}`,

    '& svg': {
      fontSize: '1.25rem !important',
      width: '1.25rem !important',
      height: '1.25rem !important',
    },
  },
}))

export { useStyles }
